module.exports = __webpack_public_path__ + "static/media/18ECA31.5db97cf0.jpg";